import { cloneDeep } from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { isOptionInstrument } from '../../../utils/optionInstrument';

export const useTabs = (instrument) => {
  let initialTabs = {
    tactics: { category: null },
    overview: { category: null },
    settings: { category: null },
  };
  if (isOptionInstrument(instrument))
    initialTabs = {
      tactics: { category: null },
      overview: { category: null },
      settings: { category: null },
      optionConfig: { category: null },
    };
  const [tabList, setTabList] = useState(initialTabs);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const timeoutRef = useRef(null);

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const removeTab = (tabName) => {
    if (tabList[tabName]) {
      const objectCopy = cloneDeep(tabList);
      delete objectCopy[tabName];
      setTabList(objectCopy);
    }
    const timer = setTimeout(() => {
      setSelectedIndex(0);
    }, 30);
    timeoutRef.current = timer;
  };
  const clearTabsOnRestart = () => {
    setTabList(initialTabs);
  };
  const clearUnusedTabsUponEntry = () => {
    const arr = Object.entries(tabList);
    arr.forEach(([key, { category }]) => {
      if (
        category === 'Setup' ||
        category === 'Setup Filter' ||
        category === 'Entry'
      ) {
        if (selectedIndex === 0) setSelectedIndex(1);
        else setSelectedIndex(0);
        delete tabList[key];
      }
    });
  };
  const addTab = (tabName, category) => {
    if (!tabList[tabName]) {
      setTabList((prev) => ({ ...prev, [tabName]: { category } }));
      setSelectedIndex(Object.keys(tabList).length);
      return true;
    } else {
      const array = Object.keys(tabList);
      const index = array.findIndex((element) => element === tabName);
      setSelectedIndex(index);
    }
  };

  return {
    tabList,
    addTab,
    removeTab,
    selectedIndex,
    setSelectedIndex,
    clearUnusedTabsUponEntry,
    clearTabsOnRestart,
  };
};
